import SpriteFrameHolder from "../../../public/ui/spriteFrameHolder";
import EventManager from "../../../../manager/event_manager";
import AudioManager from "../../../../manager/audio_manager";

const {ccclass, property} = cc._decorator;

@ccclass
export class WelfareAnimComp extends cc.Component {

    private icons:cc.Sprite[] = [];

    private fuzzy:cc.Sprite[] = [];

    @property(SpriteFrameHolder)
    spriteHold:SpriteFrameHolder = null;

    anims:cc.Animation = null;

    private startNumb:number = 0;
    private showNumb:number = 0;
    onLoad(){
        this.anims = this.getComponent(cc.Animation);
        let childs = this.node.children;
        for (let i = 0; i < childs.length; i++) {
            let icon = childs[i].getChildByName('Icon').getComponent(cc.Sprite);
            let fuzzy = childs[i].getChildByName('FuzzyIcon').getComponent(cc.Sprite);
            this.icons.push(icon);
            this.fuzzy.push(fuzzy);
        }
    }

    onStartAnim(){
        this.stopAnim()
        this.icons[2].spriteFrame = this.spriteHold.getSpriteFrameByKey('b');
        this.icons[2].node.active = true;
        this.fuzzy[2].node.active = false;
    }

    beginAnim(numb:number){
        this.showNumb = numb;
        this.anims.play('Reward_start');
        this.icons[2].spriteFrame = this.spriteHold.getSpriteFrameByKey('b');
        this.fuzzy[2].spriteFrame = this.spriteHold.getSpriteFrameByKey('ab');
        this.fillIconsSprite(true,0);
        
    }

    //动画事件
    changeNumber(){
       this.startNumb = 0;
       this.fillIconsSprite(false,this.startNumb);
    }

    canChangeItem(){
       this.changeNumbSprite(this.showNumb);
       EventManager.instance.dispatch('_welfare_anim_over');
    }

    cycleIcon(){
        this.startNumb+=5;
        this.fillIconsSprite(false,this.startNumb);
    }

    animOver(){
        WelfareAnimComp.playDayWelfareSound('gold_stop');
    }

    startEnd(){
        this.anims.play('Reward_running');
        let delay = cc.delayTime(0.6);
        this.node.runAction(cc.sequence(delay,cc.callFunc(()=>{
            this.anims.play('Reward_stop');
        })))
    }

    private fillIconsSprite(isBreak:boolean,startIndex:number){
        for (let i = 0; i < 5; i++) {
            let icon = this.icons[i];
            let fuzzy = this.fuzzy[i];
            let index = (startIndex + i) % 9;
            fuzzy.node.active = true;
            icon.node.active = true;
            if (i==2 && isBreak) {
                continue;
            }
            icon.spriteFrame = this.spriteHold.getSpriteFrameByKey(index + '');
            fuzzy.spriteFrame = this.spriteHold.getSpriteFrameByKey('a' + index);
          
        }
    }

    private changeNumbSprite(showNumb:number){
        let top = (showNumb + 1) > 9 ? 0:(showNumb+1);
        let down = (showNumb-1) < 0 ? 9:(showNumb-1) ;
        let getSprite = (number:number,isFuzzy:boolean)=>{
            return this.spriteHold.getSpriteFrameByKey(isFuzzy ?'a' + number:number+'')
        }
        this.icons[2].spriteFrame = getSprite(showNumb,false);
        this.icons[1].spriteFrame = getSprite(down,false);
        this.icons[3].spriteFrame = getSprite(top,false);

        this.fuzzy[2].spriteFrame = getSprite(showNumb,true);
        this.fuzzy[1].spriteFrame = getSprite(down,true);
        this.fuzzy[3].spriteFrame = getSprite(top,true);
    }

    stopAnim(){
        this.anims.pause('Reward_running')
        this.anims.pause('Reward_stop')
        this.anims.play('Reward_start')
        this.anims.setCurrentTime(0,'Reward_start');
        this.anims.pause('Reward_start')
        this.node.stopAllActions();
    }

    static playDayWelfareSound(name:string,func1?:Function,func2?:Function){
        AudioManager.instance.playSound('package/hall/module/daywelfare/sound/' + name, false,func1,func2)
    }

    static stopDayWelfareSound(id:number){
        AudioManager.instance.stopSound(id)
    }
}
